import { render, staticRenderFns } from "./GoogleConsentStats.vue?vue&type=template&id=5af21bc4"
import script from "./GoogleConsentStats.vue?vue&type=script&lang=js"
export * from "./GoogleConsentStats.vue?vue&type=script&lang=js"
import style0 from "./GoogleConsentStats.vue?vue&type=style&index=0&id=5af21bc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports